import { useEffect } from 'react';
import { useState } from 'react';
import { createContext } from 'react';
import { getCurrentMenu, setCurrentMenu } from '../Core/Service/LocalStorageService';
import { useNavigate } from 'react-router-dom';

const CmsContext = createContext({});

const initialMenu = getCurrentMenu();

export const CmsProvider = ({children}) => {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(initialMenu ? true : false);
    const [currMainMenu, setCurrMainMenu] = useState(initialMenu?.mainMenu);
    const [currSubMenu, setCurrSubMenu] = useState(initialMenu?.subMenu);
    const [breadcrumb, setBreadcrumb] = useState();

    useEffect(() => {
        setCurrentMenu({
            mainMenu: currMainMenu,
            subMenu: currSubMenu,
        })
    }, [currMainMenu, currSubMenu])

    return (
        <CmsContext.Provider value={{
            sidebarCollapsed, setSidebarCollapsed,
            currMainMenu, setCurrMainMenu,
            currSubMenu, setCurrSubMenu,
            breadcrumb, setBreadcrumb,
        }}>
            {children}
        </CmsContext.Provider>
    )
};

export default CmsContext;